import React from 'react';
import facility1 from '../img/1.avif';
import facility2 from '../img/2.avif';
import facility3 from '../img/a4.jpg';
import facility4 from '../img/5.avif';


const facilities = [
  { id: 1, title: 'Playground', icon: 'fa fa-child', img: facility1, text: 'Spacious, safe playground for outdoor activities and sports.' },
  { id: 2, title: 'Our Infrastructure', icon: 'fa fa-music', img: facility2, text: 'Infrastructure helps the students to up bring themselves in flying colours' },
  { id: 3, title: 'Extra Curicular Activities', icon: 'fa fa-paint-brush', img: facility3, text: 'Creative studio for developing artistic talents.' },
];

export default function Facilities(){
  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container">
        <div className="text-center mb-4">
          <p className="section-title px-5"><span className="px-2">Our Facilities</span></p>
          <h1 className="mb-4">What We Offer</h1>
        </div>
        <div className="row">
          {facilities.map(f => (
            <div className="col-md-4 mb-4" key={f.id}>
              <div className="card border-0 shadow-sm h-100">
                <img src={f.img} className="card-img-top" alt={f.title} style={{height:'200px', objectFit:'cover'}} />
                <div className="card-body">
                  <h5 className="card-title"><i className={`${f.icon} text-primary mr-2`}></i>{f.title}</h5>
                  <p className="card-text">{f.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
